<button [buttonType]="'primary'"
    class="mat-simple-snackbar-action"
    *ngIf="hasAction"
    (click)="dismiss()">{{action}}</button>
<span class="custom-snackbar-text">{{message}}</span>